import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { WidgetContentGuttersComponent } from './widget-content-gutters.component';
import { WidgetComponent } from './widget.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule
  ],
  exports: [WidgetContentGuttersComponent, WidgetComponent],
  declarations: [WidgetContentGuttersComponent, WidgetComponent],
  providers: []
})
export class WidgetsModule {}
